/* eslint-disable @stylistic/max-len */
import type {RefObject} from 'react';

/**
 * The `CastleIconProps` interface defines the properties for the CastleIcon component.
 */
interface CastleIconProps {
    /** CSS class to override default styling. */
    className?: string;
    /** Primary color of the icon. */
    color1?: string;
    /** Height of the icon. */
    height?: number | string;
    ref?: RefObject<SVGSVGElement>;
    /** Test ID for Cypress. */
    testId?: string;
    /** Width of the icon. */
    width?: number | string;
}

/**
 * Material Symbol "castle" — outlined, weight 300.
 * Castle icon for the Geschichte (History) category.
 *
 * @param props           The component props.
 * @param props.className CSS class override.
 * @param props.color1    Primary icon color.
 * @param props.height    Icon height.
 * @param props.ref       SVG element ref.
 * @param props.testId    Test identifier.
 * @param props.width     Icon width.
 * @returns A React SVG element.
 */
export const CastleIcon = ({
    className = '',
    color1 = 'currentColor',
    height,
    ref,
    testId = 'CastleIcon',
    width
}: CastleIconProps) => (
    <svg
        ref={ref}
        className={className}
        data-cy={testId}
        fill={color1}
        height={height}
        viewBox="0 -960 960 960"
        width={width}
        xmlns="http://www.w3.org/2000/svg"
    >
        <path d="M50-130v-452.69h45.38v80h121.93V-830h45.38v80h114.62v-80h45.38v80h114.62v-80h45.38v80h114.62v-80h45.38v327.31h121.93v-80H910V-130H577.31v-110q0-41.08-28.12-69.19-28.11-28.12-69.19-28.12t-69.19 28.12q-28.12 28.11-28.12 69.19v110H50Zm45.38-45.38h241.93V-240q0-59.92 41.38-101.31 41.39-41.38 101.31-41.38t101.31 41.38q41.38 41.39 41.38 101.31v64.62h241.93v-281.93H697.31v-247.31H262.69v247.31H95.38v281.93Zm281.93-321.93h45.38v-96.54h-45.38v96.54Zm160 0h45.38v-96.54h-45.38v96.54ZM480-440Z" />
    </svg>
);

CastleIcon.displayName = 'CastleIcon';